import Base from './condition-base'
import renderFields from './webview-click.pug'

export default class WebviewClick extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
